module.exports = __webpack_public_path__ + "static/img/10.ba97ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/10.png
// module id = nu5d
// module chunks = 0